import TenantPage from 'layouts/TenantPage';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { loadingActions } from 'store';
import { useAppDispatch } from 'store/store';
import toast from 'shared/utils/toast';
import MovementReasonsForm from '../components/MovementReasonsForm';
import { IMovementReason } from '../types';
import { movementReasonService } from '../../api/movement-reason.service';

export const EditMovementReason = () => {
  const translationPrefix = 'pages.reason.edit';
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const { movementReasonId } = useParams();
  const [movementReason, setMovementReason] = useState<IMovementReason>();

  useEffect(() => {
    movementReasonService.get(+movementReasonId).then(setMovementReason);
  }, []);

  const updateMovementReason = async (values) => {
    dispatch(loadingActions.startLoading());
    movementReasonService.update(movementReason.id, values).then((res) => {
      toast.crud.successUpdate('Causale', 'f');
      setMovementReason(res);
    });
    dispatch(loadingActions.stopLoading());
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      entityCode={movementReason?.code}>
      <MovementReasonsForm movementReason={movementReason} onSubmit={updateMovementReason} />
    </TenantPage>
  );
};

export default EditMovementReason;
